import React from "react";
import { NavLink } from "react-router-dom";
import './Nav.css';

const Nav = () => {
    return(
        <div className='nav'>
            <ul>
                <NavLink to="/" end><li>Hussystem</li></NavLink>
                <NavLink to="/varmeLayout"><li>Värmesystem</li></NavLink>
            </ul>
        </div>
    );
};
export default Nav;